import * as React from 'react'

import Dashboard from '@material-ui/icons/Dashboard'
import Person    from '@material-ui/icons/Person'

/*
 the reason this is imported separately is because there is a circular
 dependency failure happening if this is not being done, not sure how
 or why it's happening but I'm going to leave it like that for now
 */

import {
  Account,
  EditEducation,
  EditExperience,
  EditPersonalInformation,
}                                              from '../components/environments'
import App                                     from '../components/environments/App'
import { ExperienceType, Routing, SubRouting } from '../types'
import ProgramRouting                          from './ProgramRouting'

const dashboardRouting: SubRouting = [
  {
    name:      'programs',
    path:      '/programs',
    component: ProgramRouting,
  },
]

const profileRouting: SubRouting = [
  {
    name:      'personal',
    path:      '/personal',
    component: EditPersonalInformation,
  },
  {
    name:      'education',
    path:      '/education',
    component: () => <EditEducation experienceType={ExperienceType.NORMAL} />,
  },
  {
    name:      'experience',
    path:      '/experience',
    component: () => <EditExperience experienceType={ExperienceType.NORMAL} />,
  },
  {
    name:      'account',
    path:      '/account',
    component: Account,
  },
]

const routing: Routing = [
  {
    name:       'dashboard',
    path:       '/dashboard',
    icon:       <Dashboard />,
    subrouting: dashboardRouting,
  },
  {
    name:       'profile',
    path:       '/profile',
    icon:       <Person />,
    subrouting: profileRouting,
  },
]

export default () => <App routing={routing} />



// WEBPACK FOOTER //
// ./src/routing/Coachee.tsx